import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Form, Container } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import Confirm from "../Confirm";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import { useNavigate } from "react-router-dom";
// React Icons Starts Here
import { BsChevronRight } from "react-icons/bs";
import moment from "moment";
import Select from "react-select";
//React Icons Ends here.

const ItemList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [tempBody, setTempBody] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState([]);
  const [supplierOption, setOptionSupplier] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [itemOption, setOptionItem] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [branchOption, setOptionBranch] = useState([]);
  const [selectedbranch, setSelectedBranch] = useState({});
  const [clientOption, setOptionClient] = useState([]);
  const [selectedClient, setSelectedClient] = useState({});
  const [vechicleOption, setOptionVechicle] = useState([]);
  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [challanData, setChallanData] = useState({
    from_challan_date: "",
    to_challan_date: "",
  });
  // {from_challan_date: moment().format('YYYY-MM-DD'),
  //   to_challan_date: moment().format('YYYY-MM-DD')}

  useEffect(() => {
    fetchAlItems();
    fetchData();
  }, []);

  const fetchData = async () => {
    const fnYear = await trasportApi.fetchAllActiveFinancialYears();
    const branchRec = await trasportApi.fetchAllDrivers();
    const vechicleRec = await trasportApi.fetchAllVehicles();

    if (fnYear && fnYear.length) {
      let ar = [];
      fnYear.forEach((item) => {
        ar.push({ value: item.id, label: item.name });
      });

      const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
      const currentYear = new Date().getFullYear();
      let defaultOption;

      if (currentMonth >= 3) {
        // March is the 3rd month
        defaultOption = ar.find(
          (option) => option.label === `${currentYear}-${currentYear + 1}`
        );
      } else {
        defaultOption = ar.find(
          (option) => option.label === `${currentYear - 1}-${currentYear}`
        );
      }

      if (defaultOption) {
        setSelectedFinancialYear(defaultOption);
        setChallanData({
          ...challanData,
          financial_year_id: defaultOption.value,
        });
      }
      setOptionFinancialYear(ar);
    } else {
      setOptionFinancialYear([]);
    }

    //Branch Api Data.
    if (branchRec && branchRec.length) {
      let ar = [];
      branchRec.forEach((item) => {
        ar.push({ value: item.id, label: item.driver_name });
      });
      setOptionBranch(ar);
    } else {
      setOptionBranch([]);
    }

    //Vechile Api Data.
    if (vechicleRec && vechicleRec.length) {
      let ar = [];
      vechicleRec.forEach((item) => {
        ar.push({ value: item.id, label: item.vehicle_number });
      });
      setOptionVechicle(ar);
    } else {
      setOptionVechicle([]);
    }
  };

  const fetchAlItems = () => {
    async function init() {
      const item = await trasportApi.fetchAllDriverPayment();
      console.log("Driver", item);
      if (item) {
        setBody(item);
        setTempBody(item);
      } else {
        setBody([]);
        setTempBody([]);
      }
    }
    init();
  };

  // ,,financial_year_id,,,country,pincode,pan_number,gst_no,tin_no,ecc_no,remark

  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: "Driver Name",
      prop: "driver_name",
      isFilterable: true,
      cell: (row) => (
        <span>
          <Link to={"/driverpayments/" + row.id} state={row}>
            {row.driver_name}
          </Link>
        </span>
      ),
    },
    {
      title: "Vehicle Number",
      prop: "vehicle_number",
      isFilterable: true,
      cell: (row) => <span>{row.vehicle_number}</span>,
    },
    {
      title: "Pay Date",
      prop: "pay_date",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.pay_date ? moment(row.pay_date).format("DD MMM, yyyy") : ""}
        </span>
      ),
    },
    {
      title: "Pay Amount",
      prop: "payamount",
      isFilterable: true,
      cell: (row) => <span>{row.payamount}</span>,
    },
    {
      title: "Debit Amount",
      prop: "debit_amount",
      isFilterable: true,
      cell: (row) => <span>{row.debit_amount}</span>,
    },
    {
      title: "Pay Balance",
      prop: "paybalance",
      isFilterable: true,
      cell: (row) => <span>{row.paybalance}</span>,
    },
    {
      title: "Process",
      prop: "payment_status",
      isFilterable: true,
      cell: (row) => <span>{row.payment_status}</span>,
    },
    {
      title: "Remark",
      prop: "remark",
      isFilterable: true,
      cell: (row) => <span>{row.remark}</span>,
    },
    {
      title: "Created By Name",
      prop: "createdbyname",
      isFilterable: true,
      cell: (row) => <span>{row.createdbyname}</span>,
    },
    {
      title: "Created Date",
      prop: "createddate",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.createddate
            ? moment(row.createddate).format("DD MMM, yyyy HH:mm:ss")
            : ""}
        </span>
      ),
    },
  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createClient = () => {
    navigate(`/driverpayments/e`);
  };

  const onFilterTypeYear = async (event) => {
    var arr = [];
    tempBody.forEach((item) => {
      if (item.financial_year_name === event.target.value) {
        arr.push(item);
      } else {
        arr.push();
      }
    });
    setBody(arr.length > 0 ? arr : tempBody);
  };

  //Item
  const handleItem = (e) => {
    setSelectedItem(e);
    setChallanData({ ...challanData, item_id: e.value });
  };

  //Client
  const handleClient = (e) => {
    setSelectedClient(e);
    setChallanData({ ...challanData, client_id: e.value });
  };

  //Branch
  const handleBranch = (e) => {
    setSelectedBranch(e);
    setChallanData({ ...challanData, driver_id: e.value });
  };

  //Vehicle
  const handleVehicle = (e) => {
    setSelectedVechicle(e);
    setChallanData({ ...challanData, vehicle_id: e.value });
  };
  const handleChange = (e) => {
    setChallanData({ ...challanData, [e.target.name]: e.target.value });
  };
  const handleSearch = async (e) => {
    const result = await trasportApi.fetchAllFilterDriverPayment(challanData);
    console.log("result", result);
    setBody(result);
  };

  const handleClear = () => {
    setChallanData({
      from_challan_date: "", // Clears the date fields
      to_challan_date: "", // Clears the date fields
      driver_id: "", // Clears other fields if required
      vehicle_id: "",
      financial_year_id: "",
    });
    window.location.reload();
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ClientPaymentList}</title>
        </Helmet>
      </>

      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight />
          Driver Payment List
        </Col>
        <Row
          style={{ border: "2px solid #000000", padding: "10px" }}
          className="mx-1"
        >
          <p
            style={{
              fontSize: "22px",
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            Search Driver Payment Details
          </p>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                Select Financial Year
              </Form.Label>
              <Form.Select
                aria-label="Enter Financial Year"
                name="financial_year_name"
                onChange={onFilterTypeYear}
              >
                <option value="">--Select Financial Year--</option>
                <option value="">All</option>
                {financialYearOption.map((option) => (
                  <option key={option.value} value={option.label}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                From Payment Date
              </Form.Label>
              <Form.Control
                type="date"
                name="from_challan_date"
                // value={moment().format('YYYY-MM-DD')}
                value={challanData.from_challan_date}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                To Payment Date
              </Form.Label>
              <Form.Control
                type="date"
                name="to_challan_date"
                value={challanData.to_challan_date}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                Select Driver
              </Form.Label>
              <Select
                placeholder="Select Branch Name"
                value={selectedbranch}
                onChange={handleBranch}
                options={branchOption}
              ></Select>
              <Form.Control.Feedback type="invalid">
                Please Select Branch Name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                Vehicle Number
              </Form.Label>
              <Select
                placeholder="Select Vehicle Name"
                value={selectedVechicle}
                onChange={handleVehicle}
                options={vechicleOption}
              ></Select>
              <Form.Control.Feedback type="invalid">
                Please Select Vehicle Name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Button variant="success" className="mt-5" onClick={handleSearch}>
              Search
            </Button>
            <Button
              variant="secondary"
              className="mt-5 mx-3"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Col>
        </Row>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions labels={labels} />
                  <InfoPill left="Total" right={body?.length} />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createClient()}
                  >
                    New Driver Payment
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <Container>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  😔 No Data Found
                </span>
              </div>
              <ShimmerTable row={10} col={8} />
            </Container>
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default ItemList;
